/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { 
  useGET_courseComponentsQuery,
} from 'redux/api/coursesApi'

import { Form, Formik } from 'formik'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import CheckboxField from 'components/atoms/fields/CheckboxField'

const SyllabusSetupGradingForm: FC = () => {
  const { t } = useTranslation()
  
  const { data: gradingItems } = useGET_courseComponentsQuery({page: 1, default_only: 'true'})
  //const [POST_courseSetupMainData, { error: formError }] = usePOST_courseSetupMainMutation()
  //useErrorAlert(formError)
 
  const serverValues = {
    options: gradingItems?.results?.map(item => {return {
      key: item.id,
      title: item.title,
      enabled: true
    }}) ?? []
  }

  return (
    <>
    <Formik
      enableReinitialize
      initialValues={serverValues}
      onSubmit={(values) => {
      }}
    >
      {
        ({ values, setFieldValue, errors }) => 
        <Form>
            {values["options"].map((option,index) => 
              <Grid rowSpacing={4} columnSpacing={4} container alignSelf='baseline' key={index}>
                <Grid item xs={12} md={4}>
                  <CheckboxField 
                    isSwitch={true}
                    hasLine={true}
                    index={index}
                    valueSelector='enabled'
                    fieldProps={{
                      label: option.title,
                      name: `options[${index}]`
                    }} 
                    onChange={(value)=> {
                    }}
                  />
                </Grid>
              </Grid>
            )}
        </Form>
      }
    </Formik>
    </>
  )
}
export default SyllabusSetupGradingForm

